export default {
    env: process.env.NODE_ENV,
    development: {
        ajaxUrl: "",
        staticUrl: "",
        cookiePath: "/"
    },
    production: {
        ajaxUrl: "",
        staticUrl: "",
        cookiePath: "/"
    },
    GENDER_MAP: {
        MALE: "男",
        FEMALE: "女",
    },

    STUDENT_STATUS: {
        ACTIVE: "在校",
        SUSPENDED: "休学",
        DROPPED_OUT: "退学",
        TRANSFERRED_IN: "转入",
        TRANSFERRED_OUT: "转出",
    },

    KINSFOLK_STATUS: {
        NO_MATCH: "待匹配",
        MATCHED: "待认证",
        ACCEPTED: "已认证",
        DECLINED: "已驳回",
        INVALID: "已失效",
    },
    EDUCATION_LEVEL: {
        COLLEGE: "大学专科",
        BACHELOR: "大学本科",
        MASTER: "硕士研究生",
        DOCTOR: "博士研究生",
        OTHER: "其他"
    },
    ALBUM_STATUS: {
        INITIALIZED: "未定稿",
        FINALIZED: "已定稿",
    },
    ALBUM_DIGTAL_STATUS: {
        READY_FOR_GENERATION: "提交生成中",
        IN_GENERATION_QUEUE: "生成队列中",
        GENERATING: "电子版生成中",
        GENERATION_FAILED: "电子版生成失败",
        GENERATED: "已生成电子版",
    },
    ASSESSMENT_STATUS: {
        INITIALIZED: "评估中",
        FINISHED: "已完成",
        SENT: "已发送",
        SKIPPED: "无需评估"
    },
    FREQUENCY_MAP: {
        DAILY: "今日",
        WEEKLY: "本周",
        MONTHLY: "本月"
    }
}